/**
 * Cookie plugin
 *
 * Copyright (c) 2006 Klaus Hartl (stilbuero.de)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */

jQuery.cookie = function (b, j, m) {
  if (typeof j != "undefined") {
    m = m || {};
    if (j === null) {
      j = "";
      m.expires = -1;
    }
    var e = "";
    if (m.expires && (typeof m.expires == "number" || m.expires.toUTCString)) {
      var f;
      if (typeof m.expires == "number") {
        f = new Date();
        f.setTime(f.getTime() + m.expires * 24 * 60 * 60 * 1000);
      } else {
        f = m.expires;
      }
      e = "; expires=" + f.toUTCString();
    }
    var l = m.path ? "; path=" + m.path : "";
    var g = m.domain ? "; domain=" + m.domain : "";
    var a = m.secure ? "; secure" : "";
    document.cookie = [b, "=", encodeURIComponent(j), e, l, g, a].join("");
  } else {
    var d = null;
    if (document.cookie && document.cookie != "") {
      var k = document.cookie.split(";");
      for (var h = 0; h < k.length; h++) {
        var c = k[h].trim();
        if (c.substring(0, b.length + 1) == b + "=") {
          try {
            d = decodeURIComponent(c.substring(b.length + 1));
          } catch (error) {
            d = null;
          }
          break;
        }
      }
    }
    return d;
  }
};

/**
 * Module to show Recently Viewed Products
 *
 * Copyright (c) 2014 Caroline Schnapp (11heavens.com)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */

Shopify.Products = (function () {
  if (Shopify.Products && Shopify.Products.cuffRecentlyViewed) return Shopify.Products;

  var createProducts = function () {
  var config = {
    howManyToShow: 3,
    howManyToStoreInMemory: 10,
    wrapperId: "recently-viewed-products",
    templateId: "recently-viewed-product-template",
    layout: "slider",
    swipe: true,
    media: "adapt",
    onComplete: null,
  };
  var productHandleQueue = [];
  var wrapper = null;
  var template = null;
  var shown = 0;
  var shownSection = 0;
  var cookie = {
    configuration: {
      expires: 90,
      path: "/",
      domain: window.location.hostname,
    },
    name: "shopify_recently_viewed",
    write: function (recentlyViewed) {
      var value = recentlyViewed.join(" ");
      try {
        jQuery.cookie(this.name, value, this.configuration);
      } catch (error) {}
      try {
        localStorage.setItem(this.name, value);
      } catch (error) {}
    },
    read: function () {
      var cookieValue = null;
      try {
        cookieValue = jQuery.cookie(this.name);
      } catch (error) {}
      if (!cookieValue) {
        try {
          cookieValue = localStorage.getItem(this.name);
        } catch (error) {}
      }
      return Array.from(new Set((cookieValue || "").split(/\s+/).filter(function (handle) {
        return handle && !/[/?#]/.test(handle);
      })));
    },
    destroy: function () {
      try {
        jQuery.cookie(this.name, null, this.configuration);
      } catch (error) {}
      try {
        localStorage.removeItem(this.name);
      } catch (error) {}
    },
    remove: function (productHandle) {
      var recentlyViewed = this.read();
      var position = jQuery.inArray(productHandle, recentlyViewed);
      if (position !== -1) {
        recentlyViewed.splice(position, 1);
        this.write(recentlyViewed);
      }
    },
  };

  var handleLowResImages = function (scope) {

      const $context = scope ? $(scope) : $(document);
      
      $context.find(".high-res").each(function () {
        const img = this;
        const $parent = $(img).parent();

        const removeLowRes = () => {
            const $lowRes = $parent.find(".low-res");
            if ($lowRes.length) {
                $lowRes.remove();

            }
        };

        if (img.complete) 
            removeLowRes();
        else 
          img.onload = removeLowRes;
            
      });
  };

  var finalize = function () {
    var items = wrapper.find(".item");
    if (template === "recently-viewed-product-popup" && items.length <= 2) wrapper.addClass("center");
    wrapper.addClass("recently-viewed-loaded");

    wrapper.show();
    wrapper.closest("[data-recently-viewed-block]").attr("aria-busy", "false");
    // If we have a callback.
    if (config.onComplete) {
      try {
        config.onComplete();
      } catch (error) {}
    }
  };

  var moveAlong = function (wrapperP) {
    if (productHandleQueue.length && shown < config.howManyToShow) {
      var url =
        (window.routes?.root || "/").replace(/\/$/, "") +
        "/products/" +
        encodeURIComponent(productHandleQueue[shown]) +
        "?view=ajax_recently_viewed";

      jQuery.ajax({
        type: "get",
        url: url,
        cache: false,
        dataType: "html",
        headers: { Accept: "text/html" },
        success: function (product) {
          if (productHandleQueue[shown] !== "") wrapperP.append(product);
          shown++;
          moveAlong(wrapperP);
        },
        error: function (xhr) {
          if (xhr.status === 404 || xhr.status === 410) cookie.remove(productHandleQueue[shown]);
          shown++;
          moveAlong(wrapperP);
        },
      });
    } else {
      finalize();
    }
  };

  var doAlong = function (wrapperS) {
    const recentlyViewed = wrapperS.parents(".halo-recently-viewed-block");
    const sectionId = recentlyViewed.attr("sectionid");

    if (productHandleQueue.length && shownSection < config.howManyToShow) {
      var url =
        (window.routes?.root || "/").replace(/\/$/, "") +
        "/products/" +
        encodeURIComponent(productHandleQueue[shownSection]) +
        "?view=ajax_section_recently_viewed";

      jQuery.ajax({
        type: "get",
        url: url,
        cache: false,
        dataType: "html",
        headers: { Accept: "text/html" },
        success: function (product) {
          if (productHandleQueue[shownSection] !== "") wrapperS.append(product);
          if (shownSection == 0) {
            const productLoading = wrapperS
              .find(".product-item--loadingNoInfo")
              .parents(".product");
            productLoading.remove();
          }
          shownSection++;
          doAlong(wrapperS);

          recentlyViewed
            .find(
              ".card:not([data-recently-viewed-ids]) .variants-popup-content .selector-wrapper .swatch-element"
            )
            .each(function () {
              const $input = $(this).find("input");
              const $label = $(this).find("label");

              $input.attr({
                id: ($input.attr("id") || "") + sectionId,
                name: ($input.attr("name") || "") + sectionId,
              });
              $label.attr("for", ($label.attr("for") || "") + sectionId);
            });

          recentlyViewed.find(".card:not([data-recently-viewed-ids])").each(function () {
            $(this).attr("data-recently-viewed-ids", "true");
            const $qsForm = $(this).find(".variants-popup-content form");
            const $acForm = $(this).find(".card-action form");
            const $select = $(this).find(".variants-popup-content select");
            const $acButton = $(this).find(".card-action form button");
            const $qsButton = $(this).find(
              ".variants-popup-content .product-card__button2 button"
            );

            $qsForm.attr("id", ($qsForm.attr("id") || "") + sectionId);
            $acForm.attr("id", ($acForm.attr("id") || "") + sectionId);
            $select.attr("id", ($select.attr("id") || "") + sectionId);
            $acButton.attr(
              "data-form-id",
              ($acButton.attr("data-form-id") || "") + sectionId
            );
            $qsButton.attr(
              "data-form-id",
              ($qsButton.attr("data-form-id") || "") + sectionId
            );
          });
        },
        error: function (xhr) {
          if (xhr.status === 404 || xhr.status === 410) cookie.remove(productHandleQueue[shownSection]);
          shownSection++;
          doAlong(wrapperS);
        },
      });
    } else {
      wrapperS.find(".product-item--loadingNoInfo").closest(".product").remove();
      recentlyViewed.attr("aria-busy", "false");
      if (!wrapperS.find(".product").length) {
        recentlyViewed.prop("hidden", true);
        return;
      }

      handleLowResImages(wrapperS);

      if (config.layout == "slider") {
        var productGrid = wrapperS,
          itemToShow = productGrid.data("item-to-show"),
          itemDots = productGrid.data("item-dots"),
          itemDotsMb = productGrid.data("item-dots-mb"),
          itemArrows = productGrid.data("item-arrows"),
          itemArrowsMb = productGrid.data("item-arrows-mb");

        if (productGrid.length > 0) {
          if (!productGrid.hasClass("slick-initialized") && typeof productGrid.slick === "function") {
            productGrid.slick({
              mobileFirst: true,
              adaptiveHeight: true,
              vertical: false,
              infinite: true,
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: itemArrowsMb,
              dots: itemDotsMb,
              nextArrow: window.arrows.icon_next,
              prevArrow: window.arrows.icon_prev,
              rtl: window.rtl_slick,
              responsive: [
                {
                  breakpoint: 1599,
                  settings: {
                    arrows: itemArrows,
                    dots: itemDots,
                    get slidesToShow() {
                      if (
                        itemToShow !== undefined &&
                        itemToShow !== null &&
                        itemToShow !== ""
                      ) {
                        return (this.slidesToShow = itemToShow);
                      } else {
                        return (this.slidesToShow = 1);
                      }
                    },
                    get slidesToScroll() {
                      if (
                        itemToShow !== undefined &&
                        itemToShow !== null &&
                        itemToShow !== ""
                      ) {
                        return (this.slidesToScroll = itemToShow);
                      } else {
                        return (this.slidesToScroll = 1);
                      }
                    },
                  },
                },
                {
                  breakpoint: 1024,
                  settings: {
                    arrows: itemArrows,
                    dots: itemDots,
                    get slidesToShow() {
                      if (
                        itemToShow !== undefined &&
                        itemToShow !== null &&
                        itemToShow !== ""
                      ) {
                        if (itemToShow == 5) {
                          return (this.slidesToShow = itemToShow - 1);
                        } else {
                          return (this.slidesToShow = itemToShow);
                        }
                      } else {
                        return (this.slidesToShow = 1);
                      }
                    },
                    get slidesToScroll() {
                      if (
                        itemToShow !== undefined &&
                        itemToShow !== null &&
                        itemToShow !== ""
                      ) {
                        if (itemToShow == 5) {
                          return (this.slidesToScroll = itemToShow - 1);
                        } else {
                          return (this.slidesToScroll = itemToShow);
                        }
                      } else {
                        return (this.slidesToScroll = 1);
                      }
                    },
                  },
                },
                {
                  breakpoint: 991,
                  settings: {
                    arrows: itemArrowsMb,
                    dots: itemDotsMb,
                    slidesToShow: 4,
                    slidesToScroll: 4,
                  },
                },
                {
                  breakpoint: 767,
                  settings: {
                    arrows: itemArrowsMb,
                    dots: itemDotsMb,
                    slidesToShow: 3,
                    slidesToScroll: 3,
                  },
                },
                {
                  breakpoint: 320,
                  settings: {
                    arrows: itemArrowsMb,
                    dots: itemDotsMb,
                    slidesToShow: 2,
                    slidesToScroll: 2,
                  },
                },
              ],
            });
          }
        }

        if ($("body").hasClass("cursor-fixed__show")) {
          window.sharedFunctionsAnimation.onEnterButton();
          window.sharedFunctionsAnimation.onLeaveButton();
        }
      }

      if ($("body").hasClass("product-card-layout-08")) {
        window.sharedFunctions?.productCountdownCard();
      }

      window.sharedFunctions?.swapHoverVideoProductCard?.();
      finalize();
    }
  };

  return {
    resizeImage: function (src, size) {
      if (size == null) {
        return src;
      }

      if (size == "master") {
        return src.replace(/http(s)?:/, "");
      }

      var match = src.match(
        /\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?/i
      );

      if (match != null) {
        var prefix = src.split(match[0]);
        var suffix = match[0];

        return (prefix[0] + "_" + size + suffix).replace(/http(s)?:/, "");
      } else {
        return null;
      }
    },

    showRecentlyViewed: function (params) {
      var params = params || {};

      // Update defaults.
      jQuery.extend(config, params);

      // Read cookie.
      productHandleQueue = cookie.read();
      if (config.excludeCurrent) {
        var pathMatch = window.location.pathname.match(/\/products\/([^/]+)/);
        if (pathMatch) {
          var currentHandle = decodeURIComponent(pathMatch[1]);
          productHandleQueue = productHandleQueue.filter(function (handle) { return handle !== currentHandle; });
        }
      }

      // Template and element where to insert.
      template = config.templateId;
      wrapper = jQuery("#" + config.wrapperId);

      // How many products to show.
      config.howManyToShow = Math.min(
        productHandleQueue.length,
        config.howManyToShow
      );

      // If we have any to show.
      if (config.howManyToShow && wrapper.length) {
        // Getting each product with an Ajax call and rendering it on the page.
        if (template == "recently-viewed-product-popup") {
          const wrapperP = wrapper;
          moveAlong(wrapperP);
        } else {
          const wrapperS = wrapper;
          doAlong(wrapperS);
        }
      } else if (wrapper.length) {
        wrapper.closest("[data-recently-viewed-block]").prop("hidden", true).attr("aria-busy", "false");
      }
    },

    getRecentlyViewed: function () {
      return cookie.read();
    },

    getConfig: function () {
      return config;
    },

    clearList: function () {
      cookie.destroy();
    },

    recordRecentlyViewed: function (params) {
      var params = params || {};

      // Update defaults.
      jQuery.extend(config, params);

      // Read cookie.
      var recentlyViewed = cookie.read();

      // If we are on a product page.
      if (window.location.pathname.indexOf("/products/") !== -1) {
        // What is the product handle on this page.
        var productHandle = decodeURIComponent(window.location.pathname.split("/products/")[1].split("/")[0]);
        // In what position is that product in memory.
        var position = jQuery.inArray(productHandle, recentlyViewed);
        // If not in memory.
        if (position === -1) {
          // Add product at the start of the list.
          recentlyViewed.unshift(productHandle);
          // Only keep what we need.
          recentlyViewed = recentlyViewed.splice(
            0,
            config.howManyToStoreInMemory
          );
        } else {
          // Remove the product and place it at start of list.
          recentlyViewed.splice(position, 1);
          recentlyViewed.unshift(productHandle);
        }

        // Update cookie.
        cookie.write(recentlyViewed);
      }
    },
  };
  };

  var products = createProducts();
  products.showRecentlyViewed = function (params) {
    return createProducts().showRecentlyViewed(params);
  };
  products.cuffRecentlyViewed = true;
  return products;
})();

(function () {
  function initializeSections(scope) {
    var blocks = Array.from(scope.querySelectorAll("[data-recently-viewed-block]"));
    if (scope.matches?.("[data-recently-viewed-block]")) blocks.unshift(scope);
    if (!blocks.length) return;
    Shopify.Products.recordRecentlyViewed();
    var pathMatch = window.location.pathname.match(/\/products\/([^/]+)/);
    var currentHandle = pathMatch ? decodeURIComponent(pathMatch[1]) : "";

    blocks.forEach(function (block) {
      if (block.dataset.recentlyViewedReady) return;
      block.dataset.recentlyViewedReady = "true";
      var history = Shopify.Products.getRecentlyViewed().filter(function (handle) { return handle !== currentHandle; });
      if (!history.length) {
        block.hidden = true;
        return;
      }
      var row = block.querySelector(".recentlyViewed-row");
      if (!row) return;
      block.hidden = false;
      block.setAttribute("aria-busy", "true");
      function load() {
        if (!block.isConnected || block.classList.contains("ajax-loaded")) return;
        block.classList.add("ajax-loaded");
        Shopify.Products.showRecentlyViewed({
          howManyToShow: Number(block.dataset.limit) || 4,
          wrapperId: row.id,
          templateId: "recently-viewed-product-block",
          layout: block.dataset.layout,
          swipe: block.dataset.swipe === "true",
          media: block.dataset.imageRatio,
          excludeCurrent: true
        });
      }
      if ("IntersectionObserver" in window) {
        var observer = new IntersectionObserver(function (entries) {
          if (entries.some(function (entry) { return entry.isIntersecting; })) {
            observer.disconnect();
            load();
          }
        }, { rootMargin: "200px", threshold: 0 });
        observer.observe(block);
      } else {
        load();
      }
    });
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { initializeSections(document); }, { once: true });
  } else {
    initializeSections(document);
  }
  if (!Shopify.Products.cuffSectionListener) {
    Shopify.Products.cuffSectionListener = true;
    document.addEventListener("shopify:section:load", function (event) { initializeSections(event.target); });
  }
})();
